import { Button } from "@/components/Elements";
import { Form, InputField } from "@/components/Form";
import { useLogin } from "@/lib/auth";
import { getValidateRule } from "@/utils/validate";

const schema = getValidateRule(["username", "password"]);

type LoginValues = {
  username: string;
  password: string;
};

type LoginFormProps = {
  onSuccess: () => void;
};

export const LoginForm = ({ onSuccess }: LoginFormProps) => {
  const login = useLogin();

  return (
    <div>
      <Form<LoginValues, typeof schema>
        onSubmit={(values) => {
          login.mutateAsync(values).then(() => {
            onSuccess();
          });
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              label="ユーザ名"
              error={formState.errors["username"]}
              registration={register("username")}
            />
            <InputField
              type="password"
              label="パスワード"
              error={formState.errors["password"]}
              registration={register("password")}
            />

            <Button
              isLoading={login.isPending}
              type="submit"
              className="w-full"
            >
              ログイン
            </Button>
          </>
        )}
      </Form>
    </div>
  );
};
